
import { VToolbarItems } from "vuetify/lib";

// Functional component
export default VToolbarItems;
